import { ProductRepository } from "../Repository/ProductRepository";

export interface ViewProductGalleryByIdUseCase {
  invoke: (productId: number) => Promise<any>;
}

export class ViewProductGalleryById implements ViewProductGalleryByIdUseCase {
  private galeryRepo: ProductRepository;
  constructor(_ProductRepo: ProductRepository) {
    this.galeryRepo = _ProductRepo;
  }

   invoke(productId: number){
    if(!productId){
        throw new Error(
            "Your todo should have at leat 2 characters."
          );
    }
    const getData = this.galeryRepo.viewProductGalleryById(productId);
    return getData;
  }
}